import {useEventContext} from "../../contexts/EventContext";
import Skeleton from "react-loading-skeleton";
import {useCustomerContext} from "../../contexts/CustomerContext";

const Membership = ({ children }) => <>{children}</>;

const Notice = ({}) => {
    const { event, selectedPeriod } = useEventContext();
    const { isMember } = useCustomerContext();

    if (Object.keys(event).length === 0) {
        return <Skeleton />
    }

    let message = {
        'LIVE_ONLINE': isMember() ? 'This event is <strong>included</strong> in your <strong>membership.</strong>'
                : 'This event is included for <strong>free</strong> with an <strong>InvestIn membership.</strong>',
        'IN_PERSON': isMember() ? 'This event is <strong>not included</strong> in your <strong>membership.</strong>'
            : 'This fee also includes <strong>InvestIn membership</strong> for <strong>one year.</strong>'
    };

    if (! message[selectedPeriod.type]) {
       return <></>
    }

    return (
        <div className="esc-ii-w-full esc-ii-py-4 esc-ii-bg-light-grey/50 esc-ii-rounded esc-ii-mt-5">
            <p className="esc-ii-text-blue esc-ii-text-center esc-ii-font-montserrat esc-ii-text-[13px]"
               dangerouslySetInnerHTML={{ __html: message[selectedPeriod.type] }}
             />
        </div>
    )
}

Membership.Notice = Notice;
export default Membership;
